module.exports = __webpack_public_path__ + "static/media/jetblue-logo-white.33504942.svg";